const routes = [
  {
    path: '/blacklists',
    name: 'blacklists-list',
    component: () => import(/* webpackChunkName: "page/blacklists/list" */'@/views/pages/blacklists/List'),
    meta: {
      permissions: 'blacklists_read'
    }
  },
  {
    path: '/blacklists/new',
    name: 'blacklists-new',
    component: () => import(/* webpackChunkName: "page/blacklists/new" */'@/views/pages/blacklists/New'),
    meta: {
      permissions: 'blacklists_write'
    }
  },
  {
    path: '/blacklists/:id',
    name: 'blacklists-single',
    component: () => import(/* webpackChunkName: "page/blacklists/single" */'@/views/pages/blacklists/Single'),
    meta: {
      permissions: 'blacklists_read'
    }
  },
  {
    path: '/blacklists/:id/edit',
    name: 'blacklists-edit',
    component: () => import(/* webpackChunkName: "page/blacklists/edit" */'@/views/pages/blacklists/Edit'),
    meta: {
      permissions: 'blacklists_write'
    }
  },
  {
    path: '/blacklists/:id/emails',
    name: 'blacklists-emails',
    meta: {
      permissions: 'blacklists_read'
    }
  }
]

export default routes
